import Component from '@bythepixel/component-loader';
import runInView from '@bythepixel/run-in-view';

class InViewSrc extends Component {
  static selector = '[data-src]';
  #el;

  constructor(iframeEl) {
    super(iframeEl);
    this.#el = iframeEl;
    this.boundCleanup = () => this.cleanup();
    this.boundRemoveMaskStyles = () => this.removeMaskStyles();

    runInView(this.#el, () => this.init());
  }

  init() {
    this.#el.addEventListener('load', this.boundRemoveMaskStyles);
    requestAnimationFrame(() => {
      this.#el.src = this.#el.dataset.src;
    });
  }

  removeMaskStyles() {
    this.#el.addEventListener('transitionend', this.boundCleanup);
    requestAnimationFrame(() => {
      this.#el.style.transition = 'opacity 500ms ease-out';
      this.#el.style.setProperty('--image-opacity', 'initial');
    });
  }

  cleanup() {
    this.#el.removeEventListener('load', this.boundCleanup);
    requestAnimationFrame(() => {
      this.#el.removeAttribute(InViewSrc.selector.replace(/[[\]']+/g, ''));
      this.#el.style.removeProperty('transition');
    });
  }
}

export default InViewSrc;
